import { render, staticRenderFns } from "./edit-backup.vue?vue&type=template&id=5b18f5ef&"
import script from "./edit-backup.vue?vue&type=script&lang=js&"
export * from "./edit-backup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports